import { graphql } from 'react-relay';

const ShopDepartments = graphql`
query ShopDepartmentsQuery($vendorID: ID) {
  taxons(type: department, vendor_id: $vendorID) {
    id
    ref_id
    name
    logo
    caption
    type
    children(vendor_id: $vendorID) {
      name
      id
      ref_id
      type
      caption
      children(vendor_id: $vendorID) {
        name
        id
        ref_id
        type
        caption
      }
    }
  }
}
`;

export default ShopDepartments;
